// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {IconButton, Typography} from '@material-ui/core';
import {DeleteOutline, Edit} from '@material-ui/icons';

import {colors} from '../../../../../../assets/styles/colors';
import tableGuide from '../../../../../../assets/img/product-page/image-guide.svg';
import {actions as ProductPageActions} from '../../../duck';
import {useActions} from '../../../../../../utils/globalStore';
import {useIsFeatureInTier} from '../../../../../../utils/component';

import type {ProductPageAction} from '../../../duck';
import type {Theme} from '@material-ui/core';
import type {SizeChart} from '../../../duck';

type Props = {
  chart: SizeChart,
  handleEditChart: (id: string) => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  sizeGuiteItem: {
    border: `1px solid ${colors.grey300}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px',
  },
  name: {
    color: colors.grey800,
    fontWeight: 600,
    fontSize: 14,
  },
  leftContent: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  },
  actions: {
    display: 'flex',
    gap: '16px',
  },
  iconButton: {
    backgroundColor: colors.grey300,
    padding: theme.spacing(1),
  },
}));

export default function SizeChartItem(props: Props) {
  const {chart, handleEditChart} = props;
  const classes = useStyles();

  const hasProductSizeChartSection = useIsFeatureInTier('PRODUCT_SIZE_CHART');

  const deleteSizeChart: (payload: ProductPageAction) => void = useActions(
    ProductPageActions.deleteSizeChart
  );

  const handleDelete = (id: string) => {
    deleteSizeChart({
      sizeChartRequest: {
        id,
      },
    });
  };

  const handleEdit = () => {
    handleEditChart(chart.id);
  };

  return (
    <div className={classes.sizeGuiteItem}>
      <div className={classes.content}>
        <div className={classes.leftContent}>
          {chart.sizeChartType === 'IMAGE' ? (
            <img src={tableGuide} alt="table chart" />
          ) : null}
          <Typography className={classes.name} align="left">
            {chart.name}
          </Typography>
        </div>
        <div className={classes.actions}>
          <IconButton
            disabled={!hasProductSizeChartSection}
            className={classes.iconButton}
            size="small"
            onClick={handleEdit}
          >
            <Edit fontSize="small" />
          </IconButton>
          <IconButton
            disabled={!hasProductSizeChartSection}
            className={classes.iconButton}
            size="small"
            onClick={() => handleDelete(chart.id)}
          >
            <DeleteOutline fontSize="small" />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

SizeChartItem.propTypes = {
  chart: PropTypes.object.isRequired,
  handleEditChart: PropTypes.func.isRequired,
};
